<mat-card>
  <mat-card-content class="flex flex-col">
    <div class="flex flex-row xs:flex-col justify-between items-start xs:justify-start">
      <div class="title">
        {{ '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.TITLE' | translate }}
      </div>
      <a
        [href]="link$ | async"
        target="_blank"
        gtm="onOpen"
        gtmAction="ViBooks page"
        gtmCategory="refrigerantCircuitHistory"
      >
        <button mat-stroked-button color="primary">
          <span>{{
            '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.GO_TO_VIBOOKS'
              | translate
          }}</span>
          <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
        </button>
      </a>
    </div>
    <h4 class="mb-[8px]">
      {{
        '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.OUTDOOR_UNIT_MESSAGES_DESCRIPTION'
          | translate
      }}
    </h4>
    <div class="labels flex flex-row justify-start items-center">
      <div class="flex-[20%] max-w-[20%]">
        {{
          '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.LABEL.NUMBER' | translate
        }}
      </div>
      <div class="flex-[50%] max-w-[50%]">
        {{ '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.LABEL.DATE' | translate }}
      </div>
      <div class="flex-[30%] max-w-[30%]">
        {{
          '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.LABEL.ERROR_CODE'
            | translate
        }}
      </div>
      <!-- TODO - VIG-2257 commented temporarily -->
      <!-- <div class="flex-[35%] max-w-[35%]">
        {{
          '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.LABEL.ERROR_DESCRIPTION'
            | translate
        }}
      </div> -->
    </div>
    <vi-loader
      *ngIf="refrigerationCircuitMessagesStore.loading$ | async; else showData"
      data-at-loader
      [isLoading]="true"
    >
    </vi-loader>
    <ng-template #showData>
      <ng-container
        *ngIf="
          refrigerationCircuitMessagesStore.refrigerationCircuitMessages$
            | async as refrigerationCircuitMessages;
          else noEntries
        "
      >
        <ng-container *ngIf="refrigerationCircuitMessages?.length; else noEntries">
          <div class="messages-container">
            <app-refrigerant-circuit-history-item
              *ngFor="let message of refrigerationCircuitMessages"
              [message]="message"
              [boilerSerial]="data.boilerSerial"
            >
            </app-refrigerant-circuit-history-item>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>
    <ng-template #noEntries>
      <vi-alert class="flex-[100%] max-w-[100%]">
        {{ '+INSTALLATIONS.INSTALLATION.REFRIGERANT_CIRCUIT_HISTORY_MODAL.NO_DATA' | translate }}
      </vi-alert>
    </ng-template>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-close-btn
      mat-button
      color="primary"
      gtm="onPanelExpand"
      gtmAction="Refrigerant circuit history Modal"
      gtmCategory="refrigerantCircuitHistory"
      (click)="onClose()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
